import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import type { AppProps } from './types';
import { normalizeLang } from './constants';

/**
 * Drupal behavior for mounting the App Library Search React app.
 *
 * Reads configuration from data attributes on the block wrapper
 * and passes them as props to the App component.
 */
((Drupal, once) => {
  Drupal.behaviors.appLibrarySearch = {
    attach: (context, settings) => {
      once(
        'appLibrarySearch',
        '#app-library-search-app',
        context
      ).forEach((element) => {
        const wrapper = element.parentElement;
        const lang = normalizeLang(document.documentElement.lang || 'en');
        const appSettings = settings?.appLibrarySearch;

        const props: AppProps = {
          lang,
          pagingLimit: parseInt(
            wrapper?.dataset.pagingLimit || '8', 10
          ),
          displaySearch:
            wrapper?.dataset.searchDisplay === 'true',
          noResultsMessage: {
            es: appSettings?.noResultsEs,
            en: appSettings?.noResultsEn,
          }
        };

        createRoot(element).render(
          <StrictMode>
            <App {...props} />
          </StrictMode>
        );
      });
    },
  };
})(Drupal, once);
